import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
import enLang from 'element-ui/lib/locale/lang/en'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import { UrlSearch } from '@/utils/urlSearch'
import VConsole from "vconsole";

// 引入 VConsole
if (process.env.VUE_APP_BASE_API.includes("test")) {
  new VConsole();
}

const Request = new UrlSearch()
Vue.prototype.$Request = Request

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
// import Swiper from 'swiper'
// import 'swiper/dist/css/swiper.css'
import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI)
import vueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(vueAwesomeSwiper)
import { ImagePreview } from 'vant';
Vue.use(ImagePreview);
import 'swiper/css/swiper.css'
import * as filters from './filters' // global filters
import VueRouter from 'vue-router'
// import VueAMap from 'vue-amap'
// Vue.use(VueAMap)
// VueAMap.initAMapApiLoader({
//   key: '8d66a69dac8fa9687f0a86746741a6d0',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']
//   // 默认高德 sdk 版本为 1.4.4
//   // v: '1.4.4'
// })
Vue.config.ignoredElements = ['wx-open-launch-app'];

import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css';
Vue.use(VideoPlayer)
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  const { mockXHR } = require('../mock')
  mockXHR()
}
// Vue.use(Swiper)
Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  locale: enLang // 如果使用中文，无需设置，请删除
})
Vue.use(VueRouter)
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})